import { Observable } from 'rxjs';

import { EvaluationContent } from '../models/evaluation.model';
import { FileQueryParams, Result, ResultQueryParams } from '../models/result.model';
import { ListResponse } from '../models/utility.model';

export abstract class ResultGateway {
  abstract listResults(params: ResultQueryParams): Observable<ListResponse<Result>>;
  abstract getEvaluation(projectId: string, unitId: string, resultId: string): Observable<EvaluationContent[]>;
  abstract getFile(params: FileQueryParams): Observable<{ url: string }>;
}
